import React from "react";
import { Typography } from "@mui/material";
import { stepOneData } from "./stepData";

const StepOne = () => {
  return (
    <>
      <div>
        <div className=" mt-3 d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: "23.8532px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepOneData[0].heading}
          </Typography>

          <div className="d-flex flex-column gap-2">
            <ul
              style={{
                listStyle: "disc",
                fontSize: 16,
                lineHeight: "24px",
                letterSpacing: "0.08px",
                margin: 0,
                fontWeight: 500,
                fontFamily: "'Archivo',sans-serif",
              }}
            >
              {stepOneData[0].subOneList &&
                stepOneData[0].subOneList.map((item, index) => (
                  <li className="list m-0 pb-1" key={index}>
                    <strong> {item.head}</strong>
                    {item.text}
                  </li>
                ))}
            </ul>

            <div className="tips mt-3 ">
              <div id="border_line"></div>
              <div id="tip__container" className="px-2 px-sm-4 py-4">
                <div className="px-3 py-2">
                  <div className="d-flex flex-row gap-2 align-items-center">
                    <img
                      src='/Assets/Images/tongue-out.webp'
                      alt=""
                      style={{ width: 30, height: 30 }}
                    />
                    <Typography
                      sx={{
                        fontSize: 16,
                        lineHeight: "24px",
                        letterSpacing: "0.08px",
                        color: "#59266D",
                        // color: "yellow",
                        fontFamily: "'Archivo', sans-serif",
                      }}
                    >
                      MinEmi Tip:
                    </Typography>
                  </div>
                  <div className="mt-2">
                    <Typography
                      sx={{
                        fontSize: 16,
                        lineHeight: "24px",
                        letterSpacing: "0.08px",
                        color: "#1F1F1F",
                        // color: "#f8f8f8",

                        fontFamily: "'Archivo', sans-serif",
                      }}
                      dangerouslySetInnerHTML={{ __html: stepOneData[0].tip }}
                    ></Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepOne;
